  class CreateModel {
    constructor(id, 
                idCategoria, 
                nombreMarca, 
                nombreModelo, 
                agno, 
                carroceria, 
                transmision, 
                combustible){
        this.id = id ? id : 0,
        this.idCategoria = idCategoria ? idCategoria : '',
        this.nombreMarca =  nombreMarca ? nombreMarca : '',
        this.nombreModelo = nombreModelo ? nombreModelo : '',
        this.agno =  agno ? agno : 0,
        this.carroceria =  carroceria ? carroceria : '',
        this.transmision =  transmision ? transmision : '',
        this.combustible =  combustible ? combustible : 0
    }
}


export {
    CreateModel
}